import { Tooltip } from 'antd'
import { ReactNode } from 'react'

interface OutdateOrderProps {
  title?: ReactNode
}
export default function OutdateOrder(props: OutdateOrderProps) {
  const { title = '即将到期' } = props
  return (
    <Tooltip title={title} getTooltipContainer={() => document.body}>
      <span>⚡️</span>
    </Tooltip>
  )
}
import { Tooltip } from 'antd'
import { ReactNode } from 'react'

interface OutdateOrderProps {
  title?: ReactNode
}
export default function OutdateOrder(props: OutdateOrderProps) {
  const { title = '即将到期' } = props
  return (
    <Tooltip title={title} getTooltipContainer={() => document.body}>
      <span>⚡️</span>
    </Tooltip>
  )
}
